import { useSearchParams } from "react-router-dom"
import { getServer } from "../services/serverApis"
import { useCallback, useEffect, useState } from "react"
import Sidebar from "../components/Sidebar"
import Table from "../components/Table"
import { toast } from "react-toastify"
import BanClientModal from "../components/ManageServer/BanClientModal"
import ClientRanksModal from "../components/ManageServer/ClientRanksModal"
import { useSocket, useSocketEvent } from "../contexts/SocketContext"
import { useAuth } from "../lib/useAuth"

const cols = [
    {
        name: "نام مستعار",
        colSpan: 1,
    },

    {
        name: "",
        colSpan: 1,
    },
]

const ManageServer = () => {
    const { user } = useAuth()
    const { isConnected, sendMessage } = useSocket()
    const [server, setServer] = useState(null)
    const [onlineClients, setOnlineClients] = useState([])
    const [searchBar, setSearchBar] = useState("")
    const [backupsIsOpen, setBackupsIsOpen] = useState(false)
    const [rows, setRows] = useState(null)

    const [searchParams, setSearchParams] = useSearchParams()
    const serverId = searchParams.get("serverId")

    const handleOnlineList = useCallback((payload) => {
        setOnlineClients(payload)
    }, [])

    const handleClientEnter = useCallback((payload) => {
        setOnlineClients((oldClients) => {
            return [...oldClients, payload]
        })
    }, [])

    const handleClientLeave = useCallback((payload) => {
        setOnlineClients((oldClients) => {
            return oldClients.filter((c) => c.clid !== payload.clid)
        })
    }, [])

    useSocketEvent("online_users", handleOnlineList)
    useSocketEvent("client_entered", handleClientEnter)
    useSocketEvent("client_left", handleClientLeave)

    const searchBarChangeHandler = async (e) => {
        await new Promise((resolve) => setTimeout(resolve, 500))
        setSearchBar(e.target.value)
    }

    const toggleBackups = () => {
        setBackupsIsOpen(!backupsIsOpen)
    }

    const createRows = (onlines) => {
        onlines = onlines.map((c) => {
            let obj = {
                nickname: c.client_nickname,
                buttons: (
                    <span className="flex gap-2 justify-end">
                        <button
                            onClick={() => {
                                sendMessage("kick", { clid: c.clid })
                            }}
                            className="styled-button warning"
                        >
                            کیک
                        </button>
                        <BanClientModal client={c} />
                        <ClientRanksModal client={c} />
                    </span>
                ),
            }
            return obj
        })
        return onlines
    }

    useEffect(() => {
        if (user && isConnected && serverId) {
            sendMessage("manage-server", { serverId })
        }
    }, [user, isConnected])

    useEffect(() => {
        if (searchBar && searchBar !== "" && onlineClients) {
            let searchedRows = onlineClients.filter((c) => {
                if (!c.clientNickname.toString().includes(searchBar)) {
                    return false
                } else {
                    return true
                }
            })
            setRows(createRows(searchedRows))
        } else if (onlineClients) {
            setRows(createRows(onlineClients))
        }
    }, [searchBar, onlineClients])

    return <>{rows ? <Table cols={cols} rows={rows} /> : null}</>
}

export default ManageServer
